module.exports = __webpack_public_path__ + "static/media/newsImg.09feb024.png";